module.exports = __webpack_public_path__ + "img/pattern3.ce69d2b.svg";